import * as React from "react";
import {useCallback, useEffect} from "react";
import {
    Avatar,
    classNames,
    layout,
    LockStatusBadge,
    PushButton,
    useBoxLockStatus,
    usePlatform
} from "@variocube/cube-ui";
import {LockStatus} from "@variocube/app-api";
import {useLocalization} from "../../i18n";

export interface BoxControlProps {
    boxNumber: string;
    onBoxOpened?: () => void;
    disabled?: boolean;
}

export function BoxControl({boxNumber, onBoxOpened, disabled}: BoxControlProps) {
    const platform = usePlatform();
    const {t} = useLocalization();
    const lockStatus = useBoxLockStatus(boxNumber);

    const handleOpenBox = useCallback(() => platform.openBoxLock(boxNumber), [platform, boxNumber]);

    useEffect(() => {
        if (onBoxOpened && lockStatus == LockStatus.Open) {
            onBoxOpened();
        }
    }, [onBoxOpened, lockStatus]);

    return (
        <div>
            <div className={classNames(layout.vertical, layout.alignCenter, layout.marginYMedium)}>
                <Avatar size={4}>{boxNumber}</Avatar>
                {lockStatus && (
                    <div className={layout.paddingMedium}>
                        <LockStatusBadge lockStatus={lockStatus} strings={t}/>
                    </div>
                )}
                <div className={layout.marginYSmall}>
                    <PushButton onClick={handleOpenBox} disabled={disabled}>
                        {t("OpenBox")}
                    </PushButton>
                </div>
            </div>
        </div>
    )
}